import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon } from '../icons/SalesIcons';
export function GuaranteeSection() {
  return <section className="bg-[#FFFAF5] py-16 md:py-24" data-id="element-203">
      <div className="max-w-4xl mx-auto px-4" data-id="element-204">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-3xl shadow-2xl border-2 border-[#C4A882] p-8 md:p-12 text-center" data-id="element-205">
          {/* Shield Icon */}
          <div className="w-24 h-24 mx-auto mb-8 bg-gradient-to-br from-[#C4A882] to-[#9B2335] rounded-full flex items-center justify-center" data-id="element-206">
            <ShieldIcon size={48} className="text-white" data-id="element-207" />
          </div>

          <h2 className="font-heading text-3xl md:text-4xl text-[#5C4033] mb-6" data-id="element-208">
            Tu Inversión Está Protegida
          </h2>

          <div className="space-y-4 text-lg text-[#2D2926] leading-relaxed max-w-2xl mx-auto" data-id="element-209">
            <p data-id="element-210">Este curso está diseñado para entregarte resultados reales.</p>

            <p data-id="element-211">
              Stefany ha trabajado cada módulo con el mismo rigor que le
              dedicaba a su formación en enfermería:{' '}
              <strong className="text-[#9B2335]" data-id="element-212">
                precisión, claridad y cero lugar para la improvisación.
              </strong>
            </p>

            <p data-id="element-213">
              Si entras al curso, sigues el sistema y no ves valor en lo que
              aprendes, tienes nuestra política de respaldo.
            </p>

            <p className="text-xl font-bold text-[#9B2335]" data-id="element-214">
              Tu inversión es segura.
            </p>
          </div>

          {/* Trust Badge */}
          <div className="mt-8 inline-flex items-center gap-2 px-6 py-3 bg-[#FDF8F4] rounded-full border border-[#C4A882]" data-id="element-215">
            <ShieldIcon size={20} className="text-[#9B2335]" data-id="element-216" />
            <span className="font-bold text-[#5C4033]" data-id="element-217">
              Garantía de Satisfacción
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}